import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerSessionService } from '../../../core/customer/customer-session.service';
import { loginCommands } from '../../../core/customer/return-url.util';

/**
 * D9 / TC-A2 — the account area is authenticated-only. Every `account/*` route
 * requires a live customer session. When absent, bounce to the guard-free
 * `/login` route (reachable on any store) carrying a `returnUrl` so the user
 * lands back on the page they were trying to reach after signing in.
 */
export const customerAuthGuard: CanActivateFn = (route, state) => {
  const session = inject(CustomerSessionService);
  const router = inject(Router);
  const publicToken = route.paramMap.get('publicToken') ?? '';
  session.bindToken(publicToken);
  if (session.isAuthenticated()) return true;
  return router.createUrlTree(loginCommands(publicToken), { queryParams: { returnUrl: state.url } });
};
